import React from "react";
import SliderCard from './SliderCard.tsx';
import * as S from "./SliderFilter.ts";

const SliderFilter = (props) => {
  return(
    <S.SliderWrapper>
      <SliderCard filter_cards={props.filter_cards} onFilterCardClick={props.onFilterCardClick} />
    </S.SliderWrapper>
    );
  };

export default SliderFilter;
